import {
  ProjectConfiguration,
  stringifyEnvVariableAsJsonValueOrFail,
  stringifyEnvVariableOrFail,
} from '../index'

const prjConfiguration: ProjectConfiguration<'targa'> = {
  clientEnvResolver: (buildEnv, processEnv): ProcessEnv => {
    return {
      ANIA_MESSAGE_TIMEOUT: stringifyEnvVariableAsJsonValueOrFail(
        processEnv,
        'ANIA_MESSAGE_TIMEOUT'
      ),
      APP_HOST_PORT: stringifyEnvVariableOrFail(processEnv, 'APP_HOST_PORT'),
      APP_HOST_URL: stringifyEnvVariableOrFail(processEnv, 'APP_HOST_URL'),

      BACKEND_API_URL: stringifyEnvVariableOrFail(processEnv, 'BACKEND_API_URL'),
      BUILD_ENV: JSON.stringify(buildEnv),

      CHALLENGE_PROVIDER_URL: stringifyEnvVariableOrFail(processEnv, 'CHALLENGE_PROVIDER_URL'),
      COOKIE_PAGE_URL: stringifyEnvVariableOrFail(processEnv, 'COOKIE_PAGE_URL'),

      DATADOG_APPLICATION_ID: stringifyEnvVariableOrFail(processEnv, 'DATADOG_APPLICATION_ID'),
      DATADOG_CLIENT_TOKEN: stringifyEnvVariableOrFail(processEnv, 'DATADOG_CLIENT_TOKEN'),
      DATADOG_PROXY: stringifyEnvVariableOrFail(processEnv, 'DATADOG_PROXY'),
      DATADOG_SERVICE_NAME: stringifyEnvVariableOrFail(processEnv, 'DATADOG_SERVICE_NAME'),
      DYNAMIC_FLAGS_FETCHING_MODE: stringifyEnvVariableOrFail(
        processEnv,
        'DYNAMIC_FLAGS_FETCHING_MODE'
      ),

      GTM_AUTH_CODE: stringifyEnvVariableOrFail(processEnv, 'GTM_AUTH_CODE'),
      GTM_ID: stringifyEnvVariableOrFail(processEnv, 'GTM_ID'),
      GTM_PREVIEW_ID: stringifyEnvVariableOrFail(processEnv, 'GTM_PREVIEW_ID'),

      IS_BUILD_OPTIMIZED: stringifyEnvVariableAsJsonValueOrFail(processEnv, 'IS_BUILD_OPTIMIZED'),
      IS_CLAIMS_DATA_USAGE_ENABLED: stringifyEnvVariableAsJsonValueOrFail(
        processEnv,
        'IS_CLAIMS_DATA_USAGE_ENABLED'
      ),
      IS_CROSS_DOMAIN_COOKIE_ENABLED: stringifyEnvVariableAsJsonValueOrFail(
        processEnv,
        'IS_CROSS_DOMAIN_COOKIE_ENABLED'
      ),
      IS_DATADOG_ENABLED: stringifyEnvVariableAsJsonValueOrFail(processEnv, 'IS_DATADOG_ENABLED'),
      IS_DEV_ROUTER_ENABLED: stringifyEnvVariableAsJsonValueOrFail(
        processEnv,
        'IS_DEV_ROUTER_ENABLED'
      ),
      IS_ELM_BODY_PATCH_ENABLED: stringifyEnvVariableAsJsonValueOrFail(
        processEnv,
        'IS_ELM_BODY_PATCH_ENABLED'
      ),
      IS_FLAG_CHANGER_ENABLED: stringifyEnvVariableAsJsonValueOrFail(
        processEnv,
        'IS_FLAG_CHANGER_ENABLED'
      ),
      IS_PRIVATE_LOG_ENVIRONMENT: stringifyEnvVariableAsJsonValueOrFail(
        processEnv,
        'IS_PRIVATE_LOG_ENVIRONMENT'
      ),

      LAUNCHDARKLY_CLIENT_ID: stringifyEnvVariableOrFail(processEnv, 'LAUNCHDARKLY_CLIENT_ID'),
      LOGIN_PAGE_URL: stringifyEnvVariableOrFail(processEnv, 'LOGIN_PAGE_URL'),

      PRIMA_PUBLIC_HOST: stringifyEnvVariableOrFail(processEnv, 'PRIMA_PUBLIC_HOST'),

      USERPILOT_TOKEN: stringifyEnvVariableOrFail(processEnv, 'USERPILOT_TOKEN'),

      VERSION: stringifyEnvVariableOrFail(processEnv, 'VERSION'),
    }
  },
  transpilerConfiguration: {
    manifest: {
      appDescription:
        "Seleziona la polizza di cui hai bisogno, calcola un preventivo online e completa l'acquisto in pochi minuti su Prima.",
      appName: 'Prima',
      lang: 'it-IT',
    },
    preRenderedRoutes: ['targa', '404', 'targa/societa'],
    robotsTxt: {
      policy: [
        {
          allow: '/',
          userAgent: '*',
        },
      ],
    },
    startUrl: 'targa',
  },
}

/**
 * Node.js Env redeclaration. Is used by FE code too for type hints. Since is not declared
 * as an importable type we redeclare it entirely instead of extending the package type with TZ field
 *
 * This Env object is shared between webpack and the transpiled client through typescript global declarations
 * In order to reduce risk it must be Json stringified, and is "type" checked at build time
 *
 * if you need one of these values during webpack phase ***REMEMBER TO JSON PARSE THEM***
 */
export interface ProcessEnv extends NodeJS.Dict<string> {
  APP_HOST_PORT: string
  APP_HOST_URL: string

  BACKEND_API_URL: string
  BUILD_ENV: string

  CHALLENGE_PROVIDER_URL: string
  COOKIE_PAGE_URL: string

  DATADOG_APPLICATION_ID: string
  DATADOG_CLIENT_TOKEN: string
  DATADOG_PROXY: string
  DATADOG_SERVICE_NAME: string

  GTM_AUTH_CODE: string
  GTM_ID: string
  GTM_PREVIEW_ID: string

  IS_BUILD_OPTIMIZED: string
  IS_CLAIMS_DATA_USAGE_ENABLED: string
  IS_CROSS_DOMAIN_COOKIE_ENABLED: string
  IS_DATADOG_ENABLED: string
  IS_DEV_ROUTER_ENABLED: string
  IS_ELM_BODY_PATCH_ENABLED: string
  IS_PRIVATE_LOG_ENVIRONMENT: string

  LAUNCHDARKLY_CLIENT_ID: string
  LOGIN_PAGE_URL: string

  PRIMA_PUBLIC_HOST: string

  TZ?: string
  USERPILOT_TOKEN: string
  VERSION: string
}
export default prjConfiguration
